import "@inter-ikea-kompis/component-product-card/lib/components/product-card/ProductCard.js";
import WrappedComponent from "@inter-ikea-kompis/component-product-card/lib/components/product-card/ProductCard.js";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import KompisElementRegistry from '@inter-ikea-kompis/web-component/lib/registry/KompisElementRegistry.js';
class KompisProductCard extends React.Component {
    constructor() {
        super(...arguments);
        this.customElements = new KompisElementRegistry();
        this.listeners = {};
        this.ref = {
            current: null
        };
    }
    render() {
        return React.createElement(this.customElements.getInternalName("kompis-product-card"), this.getForwardedProps(), this.props.children);
    }
    componentWillUnmount() {
        this.setState({
            element: null
        });
        this.removeAllListeners(this.ref.current);
        this.ref.current = null;
    }
    componentWillMount() {
        this.customElements.define("kompis-product-card", WrappedComponent);
    }
    removeAllListeners(element) {
        for (const eventType in this.listeners) {
            const callback = this.listeners[eventType];
            if (typeof callback === 'function') {
                element.removeEventListener(eventType, callback);
            }
            delete this.listeners[eventType];
        }
    }
    updateEventListener(element, callback, eventType) {
        if (callback !== this.listeners[eventType]) {
            if (typeof callback === 'function') {
                element.removeEventListener(eventType, this.listeners[eventType]);
            }
            this.listeners[eventType] = callback;
            if (typeof callback === 'function') {
                element.addEventListener(eventType, this.listeners[eventType]);
            }
        }
    }
    getForwardedProps() {
        const forwardedProps = {
            ref: this.onRef.bind(this),
            class: this.props.className,
            'data-element-name': "kompis-product-card"
        };
        for (const key in this.props) {
            if (!(key in this['constructor']['propTypes'])) {
                forwardedProps[key] = this.props[key];
            }
        }
        return forwardedProps;
    }
    onRef(element) {
        if (element === null) {
            return;
        }
        if (element !== this.ref.current && this.ref.current !== null) {
            this.removeAllListeners(this.ref.current);
        }
        this.updateAllEventListeners(element, this.props);
        this.updateAllPropValues(element, this.props);
        this.ref.current = element;
    }
    updateAllPropValues(element, props) {
        element.analytics = props.analytics;
        element.carouselSelectedIndex = props.carouselSelectedIndex;
        element.carouselShowAll = props.carouselShowAll;
        element.carouselShowArrows = props.carouselShowArrows;
        element.carouselShowScrollbar = props.carouselShowScrollbar;
        element.carouselThumbnailLimit = props.carouselThumbnailLimit;
        element.disableLinks = props.disableLinks;
        element.functionIcons = props.functionIcons;
        element.hideTypeName = props.hideTypeName;
        element.homeDeliveryState = props.homeDeliveryState;
        element.homeDeliveryZipCode = props.homeDeliveryZipCode;
        element.hoverImageSortOrder = props.hoverImageSortOrder;
        element.imageAspectRatio = props.imageAspectRatio;
        element.imageSortOrder = props.imageSortOrder;
        element.includedProducts = props.includedProducts;
        element.infoIconButtonLinkTarget = props.infoIconButtonLinkTarget;
        element.infoIconButtonLinkUrl = props.infoIconButtonLinkUrl;
        element.layout = props.layout;
        element.localizedInformation = props.localizedInformation;
        element.measurementSystem = props.measurementSystem;
        element.media = props.media;
        element.priceModuleLayout = props.priceModuleLayout;
        element.product = props.product;
        element.productDescription = props.productDescription;
        element.productMeasures = props.productMeasures;
        element.productVariants = props.productVariants;
        element.productVariantsLimit = props.productVariantsLimit;
        element.productVariations = props.productVariations;
        element.selectBehaviour = props.selectBehaviour;
        element.selectedState = props.selectedState;
        element.selectedStateAriaLabel = props.selectedStateAriaLabel;
        element.settings = props.settings;
        element.showDesignText = props.showDesignText;
        element.showHomeDelivery = props.showHomeDelivery;
        element.showInfoIconButton = props.showInfoIconButton;
        element.showPackageMeasures = props.showPackageMeasures;
        element.showPriceExclTax = props.showPriceExclTax;
        element.showProductIdentifier = props.showProductIdentifier;
        element.showProductVariants = props.showProductVariants;
        element.showWeight = props.showWeight;
        element.storeAvailability = props.storeAvailability;
        element.storeId = props.storeId;
        element.stores = props.stores;
        element.theme = props.theme;
        element.translations = props.translations;
        element.visibleModal = props.visibleModal;
        element.zipAvailability = props.zipAvailability;
    }
    updateAllEventListeners(element, props) {
        this.updateEventListener(element, props.onCarouselChange, "carouselChange");
        this.updateEventListener(element, props.onCarouselShowAllThumbnails, "carouselShowAllThumbnails");
        this.updateEventListener(element, props.onHomeDeliveryClick, "homeDeliveryClick");
        this.updateEventListener(element, props.onHomeDeliveryForgetZipCode, "homeDeliveryForgetZipCode");
        this.updateEventListener(element, props.onHomeDeliverySaveZipCode, "homeDeliverySaveZipCode");
        this.updateEventListener(element, props.onInfoIconButtonClick, "infoIconButtonClick");
        this.updateEventListener(element, props.onModalClose, "modalClose");
        this.updateEventListener(element, props.onModalOpen, "modalOpen");
        this.updateEventListener(element, props.onProductVariantClick, "productVariantClick");
        this.updateEventListener(element, props.onProductVariantShowMoreClick, "productVariantShowMoreClick");
        this.updateEventListener(element, props.onSelect, "select");
        this.updateEventListener(element, props.onStoreSelectorChange, "storeSelectorChange");
    }
}
KompisProductCard.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    analytics: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    carouselSelectedIndex: PropTypes.number,
    carouselShowAll: PropTypes.bool,
    carouselShowArrows: PropTypes.bool,
    carouselShowScrollbar: PropTypes.bool,
    carouselThumbnailLimit: PropTypes.number,
    disableLinks: PropTypes.bool,
    functionIcons: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    hideTypeName: PropTypes.bool,
    homeDeliveryState: PropTypes.string,
    homeDeliveryZipCode: PropTypes.string,
    hoverImageSortOrder: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    imageAspectRatio: PropTypes.string,
    imageSortOrder: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    includedProducts: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    infoIconButtonLinkTarget: PropTypes.string,
    infoIconButtonLinkUrl: PropTypes.string,
    layout: PropTypes.string,
    localizedInformation: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    measurementSystem: PropTypes.string,
    media: PropTypes.string,
    priceModuleLayout: PropTypes.string,
    product: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    productDescription: PropTypes.string,
    productMeasures: PropTypes.string,
    productVariants: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    productVariantsLimit: PropTypes.number,
    productVariations: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    selectBehaviour: PropTypes.string,
    selectedState: PropTypes.string,
    selectedStateAriaLabel: PropTypes.string,
    settings: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    showDesignText: PropTypes.bool,
    showHomeDelivery: PropTypes.bool,
    showInfoIconButton: PropTypes.bool,
    showPackageMeasures: PropTypes.bool,
    showPriceExclTax: PropTypes.bool,
    showProductIdentifier: PropTypes.bool,
    showProductVariants: PropTypes.bool,
    showWeight: PropTypes.bool,
    storeAvailability: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    storeId: PropTypes.string,
    stores: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    theme: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    translations: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    visibleModal: PropTypes.string,
    zipAvailability: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    onModalClose: PropTypes.func,
    onModalOpen: PropTypes.func,
    onCarouselChange: PropTypes.func,
    onCarouselShowAllThumbnails: PropTypes.func,
    onProductVariantClick: PropTypes.func,
    onProductVariantShowMoreClick: PropTypes.func,
    onInfoIconButtonClick: PropTypes.func,
    onSelect: PropTypes.func,
    onStoreSelectorChange: PropTypes.func,
    onHomeDeliveryForgetZipCode: PropTypes.func,
    onHomeDeliverySaveZipCode: PropTypes.func,
    onHomeDeliveryClick: PropTypes.func
};
export default KompisProductCard;
